<template>
  <div class="Sidenav absolute z-sidenav" :class="open ? 'is-open' : ''">
    <lm-backdrop :open="open" @click="close" />
    <div class="Content">
      <sidenav-header @close="close" />
      <div class="Sidenav-body">
        <nav-list @select="close" />
        <pending-invitations @toHome="close" />
        <landscapes-block @toLandscape="close" />
        <div class="flex justify-center mt-4 mb-8">
          <lm-button-next
            :icon="canCreateLandscape ? 'add' : 'lock'"
            label="Create Landscape"
            @click="openNewLandscape"
          />
        </div>
      </div>
      <sidenav-footer />
    </div>
  </div>
</template>

<script>
import LandscapesBlock from '@/components/common/sidenav/LandscapesBlock'
import NavList from '@/components/common/sidenav/NavList'
import PendingInvitations from '@/components/common/sidenav/PendingInvitations'
import SidenavFooter from '@/components/common/sidenav/SidenavFooter'
import SidenavHeader from '@/components/common/sidenav/SidenavHeader'
import LmButtonNext from '@/components/ui/button/LmButtonNext'
import {Events, Modal} from '@/lib/definitions'
import eventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import LmBackdrop from './LmBackdrop'

export default {
  name: 'Sidenav',
  components: {
    SidenavHeader,
    SidenavFooter,
    LandscapesBlock,
    PendingInvitations,
    LmButtonNext,
    NavList,
    LmBackdrop
  },
  data() {
    return {
      Modal,
      open: false
    }
  },
  computed: {
    ...mapGetters(['canCreateLandscape'])
  },
  mounted() {
    eventHub.on(Events.OPEN_SIDENAV, this.openSidenav)
    eventHub.on(Events.CLOSE_SIDENAV, this.close)
    // this.openSidenav()
  },
  methods: {
    openSidenav() {
      this.open = true
      this.$store.dispatch('hideScrollbar')
    },
    close() {
      this.open = false
      this.$store.dispatch('showScrollbar')
    },
    openNewLandscape() {
      const modal = this.canCreateLandscape
        ? {modal: Modal.NEW_LANDSCAPE}
        : {submodal: Modal.UPGRADE_PLAN}
      this.$router.pushQuery(modal)
    }
  }
}
</script>

<style scoped>
.Sidenav.is-open .Content {
  overflow-y: auto;
  transform: translate3D(0, 0, 0);
}
.Content {
  position: fixed;
  top: 0;
  bottom: 0; /* Do no set height! */
  right: 0;
  z-index: 2; /* backdrop = 1 */
  transform: translate3D(100%, 0, 0);
  display: flex;
  flex-direction: column;
  width: 320px;
  background-color: #fff;
  transition: transform 0.7s cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: transform;
}
</style>
